import { formatPrice } from '@/utils/formatter';

export const getExtrasLabel = (
  extras: {
    name: string;
    price: string;
  }[],
): string =>
  extras
    .map(
      (extra: any) =>
        `${extra.name}${extra.price ? ` (${formatPrice(extra.price)})` : ''}`,
    )
    .join(', ');
